var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-editor" },
    [
      _vm.showFormatMenu && _vm.$vuetify.breakpoint.smAndUp
        ? _c(
            "div",
            { staticClass: "flex gap-1" },
            _vm._l(_vm.formatMenu, function (item, idx) {
              return _c(
                "div",
                { key: idx },
                [
                  item.icon
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            "input-value": _vm.editor?.isActive(item.name),
                            tabindex: "1",
                          },
                          on: {
                            click: function ($event) {
                              return item.apply()
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.editor?.isActive(item.name)
                                  ? "accent"
                                  : "dark",
                              },
                            },
                            [_vm._v(_vm._s(item.icon))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !item.icon
                    ? _c("v-divider", {
                        staticClass: "mx-2",
                        attrs: { vertical: "" },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("editor-content", {
        staticClass: "editor prose",
        attrs: { editor: _vm.editor },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-between" },
        [
          _c(
            "div",
            { class: { "flex gap-2": !_vm.showFormatMenu } },
            [
              false
                ? _c(
                    "v-btn",
                    { attrs: { icon: "", small: "", color: "dark" } },
                    [_c("v-icon", [_vm._v("add_circle_outline")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "", color: "dark", tabindex: "1" },
                  on: {
                    click: function ($event) {
                      ;[
                        (_vm.showFormatMenu = !_vm.showFormatMenu),
                        _vm.editor.commands.focus(),
                      ]
                    },
                  },
                },
                [_c("v-icon", [_vm._v("text_format")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showFormatMenu && _vm.$vuetify.breakpoint.xs
            ? _c(
                "div",
                { staticClass: "flex px-2 gap-1" },
                _vm._l(_vm.formatMenu, function (item, idx) {
                  return _c(
                    "div",
                    { key: idx },
                    [
                      item.icon
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "input-value": _vm.editor?.isActive(item.name),
                              },
                              on: {
                                click: function ($event) {
                                  return item.apply()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.editor?.isActive(item.name)
                                      ? "accent"
                                      : "dark",
                                  },
                                },
                                [_vm._v(_vm._s(item.icon))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !item.icon
                        ? _c("v-divider", {
                            staticClass: "mx-2",
                            attrs: { vertical: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.characterLimit &&
          _vm.editor &&
          !(_vm.showFormatMenu && _vm.$vuetify.breakpoint.xs)
            ? _c(
                "div",
                { staticClass: "caption whitespace-nowrap my-auto mr-4" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.editor.storage.characterCount.characters()) +
                      " /\n            " +
                      _vm._s(_vm.characterLimit) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }